function SvgMax(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 25 24' {...props}>
      <path d='M5 6a1 1 0 011-1h14a1 1 0 110 2H6a1 1 0 01-1-1zM12.162 8.5a.953.953 0 011.676 0l5.03 9c.373.667-.092 1.5-.838 1.5H7.97c-.746 0-1.211-.833-.839-1.5l5.03-9z' />
    </svg>
  )
}

export default SvgMax
